import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

// EmptyState: icon in a soft circle, a title, one line that says what to do next and one action.
export default function EmptyState({ icon, title, text, action }) {
  return (
    <div className="crm-rollo__empty">
      <span className="crm-rollo__empty-ico" aria-hidden="true">
        <FontAwesomeIcon icon={icon} />
      </span>
      <h4 className="crm-rollo__empty-title">{title}</h4>
      <p className="crm-rollo__empty-text">{text}</p>
      {action}
    </div>
  );
}

// Load error with "Reintentar" (design: load errors always offer a retry).
export function LoadError({ title = "No se pudieron cargar las gestiones", message, onRetry }) {
  return (
    <div className="crm-rollo__note crm-rollo__note--error" role="alert">
      <span className="crm-rollo__note-ico" aria-hidden="true">
        <FontAwesomeIcon icon={faTriangleExclamation} />
      </span>
      <b>{title}</b>
      <p>{message || "Probá de nuevo en unos segundos."}</p>
      <button type="button" className="crm-rollo__btn crm-rollo__btn--secondary" onClick={onRetry}>
        <FontAwesomeIcon icon={faRotateRight} aria-hidden="true" />
        Reintentar
      </button>
    </div>
  );
}
